import { MapPin, Phone, Mail, Instagram, ArrowUpRight, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-charcoal text-white" data-testid="main-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-2xl md:text-3xl font-light tracking-tight text-white">
                JAT FASHION HOUSE
              </span>
              <span className="block text-[10px] tracking-[0.3em] uppercase text-gold font-body font-medium mt-1">
                Wear Your Identity
              </span>
            </Link>
            <p className="text-sm text-white/70 leading-relaxed mb-6">
              Premium men's fashion crafted with excellence. 
              Experience luxury clothing at exceptional value.
            </p>
            
            {/* WhatsApp Button */}
            <a 
              href="https://wa.me/919328566392?text=Hi%20JAT%20Fashion%20House%2C%20I%20have%20a%20query"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white px-5 py-2.5 text-xs tracking-wider uppercase font-medium hover:bg-[#128C7E] transition-colors rounded-full"
              data-testid="whatsapp-button"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp Us
            </a>
          </div>

          {/* Bhuj Store */}
          <div>
            <h3 className="text-xs font-body font-semibold tracking-[0.2em] uppercase text-gold mb-5">
              Bhuj Store
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3" data-testid="location-bhuj">
                <MapPin className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <div>
                  <p className="text-sm text-white/90 leading-relaxed">
                    Ground Floor, Alfa Arcade,<br />
                    Shop No. 005, Sumra Deli Road,<br />
                    Sonivad, Bhuj - 370001
                  </p>
                </div>
              </div>
              
              <div className="flex flex-col gap-2">
                <a 
                  href="tel:+919328566392" 
                  className="flex items-center gap-2 text-sm text-white/80 hover:text-gold transition-colors"
                >
                  <Phone className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} />
                  +91 93285 66392
                </a>
                <a 
                  href="tel:+918141980608" 
                  className="flex items-center gap-2 text-sm text-white/80 hover:text-gold transition-colors"
                >
                  <Phone className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} />
                  +91 81419 80608
                </a>
              </div>
              
              <div className="flex items-center gap-4 pt-2">
                <a 
                  href="https://www.instagram.com/jat__fashion_house?igsh=MTNudHNvdjJyaHpxcg==" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center gap-1.5 text-white/70 hover:text-gold transition-colors"
                  title="Instagram - Bhuj"
                >
                  <Instagram className="w-4 h-4" strokeWidth={1.5} />
                </a>
                <a 
                  href="https://share.google/32ArVO6ALVxQlloIC" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-1.5 text-xs text-white/70 hover:text-gold transition-colors"
                  title="Google Maps - Bhuj"
                >
                  <MapPin className="w-4 h-4" strokeWidth={1.5} />
                  <span>Map</span>
                </a>
              </div>
            </div>
          </div>

          {/* Anjar Store */}
          <div>
            <h3 className="text-xs font-body font-semibold tracking-[0.2em] uppercase text-gold mb-5">
              Anjar Store
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3" data-testid="location-anjar">
                <MapPin className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <div>
                  <p className="text-sm text-white/90 leading-relaxed">
                    Near Guddi Hotel,<br />
                    Devaliya Naka,<br />
                    Anjar - 370110
                  </p>
                </div>
              </div>
              
              <div className="flex flex-col gap-2">
                <a 
                  href="tel:+918469082367" 
                  className="flex items-center gap-2 text-sm text-white/80 hover:text-gold transition-colors"
                >
                  <Phone className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} />
                  +91 84690 82367
                </a>
                <a 
                  href="tel:+919328566392" 
                  className="flex items-center gap-2 text-sm text-white/80 hover:text-gold transition-colors"
                >
                  <Phone className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} />
                  +91 93285 66392
                </a>
              </div>
              
              <div className="flex items-center gap-4 pt-2">
                <a 
                  href="https://www.instagram.com/jat_fashion_house_anjar?igsh=anNlcmgzNm8xeGxp" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center gap-1.5 text-white/70 hover:text-gold transition-colors"
                  title="Instagram - Anjar"
                >
                  <Instagram className="w-4 h-4" strokeWidth={1.5} />
                </a>
                <a 
                  href="https://share.google/2mS7TkcySxIfLGGS6" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-1.5 text-xs text-white/70 hover:text-gold transition-colors"
                  title="Google Maps - Anjar"
                >
                  <MapPin className="w-4 h-4" strokeWidth={1.5} />
                  <span>Map</span>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links & Email */}
          <div>
            <h3 className="text-xs font-body font-semibold tracking-[0.2em] uppercase text-gold mb-5">
              Quick Links
            </h3>
            <div className="space-y-3 mb-8">
              <Link to="/" className="block text-sm text-white/80 hover:text-gold transition-colors">
                Home
              </Link>
              <Link to="/products" className="block text-sm text-white/80 hover:text-gold transition-colors">
                Collections
              </Link>
              <Link to="/about" className="block text-sm text-white/80 hover:text-gold transition-colors">
                About Us
              </Link>
              <Link to="/contact" className="block text-sm text-white/80 hover:text-gold transition-colors">
                Contact
              </Link>
            </div>
            
            <div className="pt-4 border-t border-white/10">
              <a 
                href="mailto:jatfashionhouse11@gmail.com" 
                className="flex items-center gap-2 text-sm text-white/80 hover:text-gold transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4 text-gold" strokeWidth={1.5} />
                jatfashionhouse11@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/50 tracking-wider">
            © 2025 JAT FASHION HOUSE. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs text-white/50 hover:text-white/80 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-xs text-white/50 hover:text-white/80 transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
